import React, { useState, useEffect } from "react";
import { Divider, Typography, Flex, Tooltip, Select } from "antd";
import { DeleteFilled } from "@ant-design/icons";
import { CustomTitle } from "../../../components/index.js";
import { useToken } from "../../../common/helper/index.js";
import { useSpin } from "../../../components/SpinContext.js";
import { GetAlertThresholds } from "../../../api's/settings.js";
import { useNavigate } from "react-router-dom";
import { alertThresholdsConfig } from "../../Settings/AlertThresholds/AlertThresholdConfig.js";
import refreshIcon from "../../../assets/images/refreshIcon.svg";
import SensorInfoIcon from "../../../assets/images/SensorInfoIcon.jsx";
import SensorInfoIconDisabled from "../../../assets/images/SensorInfoIconDisabled.jsx";
import ShipmentAlertThresholdInput from "./ShipmentAlertThresholdInput.jsx";
const { Text } = Typography;
const ShipmentAlertThresholds = ({
  title,
  step,
  shipment,
  thresholds,
  setThresholds,
  selectedThresholds,
  setSelectedThresholds,
}) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const [patchedConfig, setPatchedConfig] = useState(alertThresholdsConfig);
  const { showSpin, hideSpin } = useSpin();
  const [teamsOptions, setTeamsOptions] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [defaultThresholds, setDefaultThresholds] = useState({});
  const [allTeamThresholds, setAllTeamThresholds] = useState({});
  const [setupSensor, setSetupSensor] = useState(false);

  console.log({ thresholds });
  console.log({ selectedThresholds });
  const setupSensorRuleIds = alertThresholdsConfig
    .flatMap((group) => group.rules)
    .filter((rule) => rule.showSensorInfoIconDisabled)
    .map((rule) => rule.id);

  const patchThresholdValues = (config, apiData) => {
    const updated = JSON.parse(JSON.stringify(config));
    const setupSensor = apiData?.setup_sensor;

    updated.forEach((group) => {
      group.rules.forEach((rule) => {
        const key = rule.id;
        if (Object.prototype.hasOwnProperty.call(apiData, key)) {
          rule.defaultValue = apiData[key];
        }

        if (setupSensorRuleIds.includes(rule.id)) {
          rule.showSetupSensorButton = !!setupSensor;
          rule.infoIconImage = setupSensor
            ? SensorInfoIconDisabled
            : SensorInfoIcon;
        }
      });
    });

    return updated;
  };

  const fetchThresholds = async () => {
    try {
      showSpin();

      let query = "";
      if (selectedTeam === "all") {
        query = "";
      } else if (Array.isArray(selectedTeam) && selectedTeam.length > 0) {
        query = `?team=${selectedTeam[0]}`;
      } else if (typeof selectedTeam === "string") {
        query = `?team=${selectedTeam}`;
      }

      const response = await GetAlertThresholds(token, query);
      const fetchedData = response?.data?.data?.data;
      setSetupSensor(fetchedData?.setup_sensor);

      if (fetchedData) {
        const patched = patchThresholdValues(
          alertThresholdsConfig,
          fetchedData
        );
        console.log('dsfdsfsdfsdfdsfdsfdsfsd',{patched})
        setPatchedConfig(patched);

        const newThresholds = {};
        patched.forEach((group) => {
          group.rules.forEach((rule) => {
            newThresholds[rule.id] = rule.defaultValue;
          });
        });

        setThresholds(newThresholds);
        if (!query) {
          console.log({ newThresholds });
          setAllTeamThresholds(newThresholds);
        }
      }
    } catch (error) {
      unauthorize(error);
    } finally {
      hideSpin();
    }
  };

  useEffect(() => {
    fetchThresholds();
  }, [selectedTeam]);

  const unauthorize = (status) => {
    if (status === 401) {
      removeToken();
      navigate("/login");
    }
  };
  useEffect(() => {
    const fetchDefaults = async () => {
      try {
        const res = await GetAlertThresholds(token, "?default=true");
        const data = res?.data?.data?.data;

        const mapped = {};
        patchThresholdValues(alertThresholdsConfig, data).forEach((group) => {
          group.rules.forEach((rule) => {
            mapped[rule.id] = rule.defaultValue;
          });
        });
        setDefaultThresholds(mapped);
      } catch (e) {
        unauthorize(e);
      }
    };

    fetchDefaults();
  }, []);

  const handleChange = (id, value) => {
    setThresholds((prev) => ({ ...prev, [id]: value }));
  };
  const handleDelete = (id) => {
    setSelectedThresholds((prev) => prev.filter((item) => item !== id));
  };

  const getDropdownOptions = (unit) => {
    switch (unit) {
      case "%":
        return Array.from({ length: 11 }, (_, i) => `${i * 10} `);
      case "mins":
        return Array.from({ length: 13 }, (_, i) => `${i * 10} `);
      case "ft":
        return Array.from({ length: 21 }, (_, i) => `${i * 100} `);
      case "Level":
        return ["L1", "L2", "L3", "L4", "L5"];
      case "X":
        return Array.from(
          { length: 18 },
          (_, i) => `${(1.5 + i * 0.5).toFixed(1)}`
        );
      default:
        return [];
    }
  };

  return (
    <>
      {step === 2 && (
        <div
          style={{
            maxWidth: "100%",
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {patchedConfig.map((group) =>
            group.rules
              .filter((rule) => selectedThresholds.includes(rule.id))
              .map((rule, index, filteredRules) => {
                const compareAgainst = defaultThresholds;
                const showResetIcon =
                  rule.showResetIcon &&
                  thresholds?.[rule.id] !== compareAgainst?.[rule.id];

                return (
                  <React.Fragment key={rule.id}>
                    <Flex
                      align="center"
                      justify="space-between"
                      style={{ marginBottom: 12, gap: 16 }}
                    >
                      <Flex vertical style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                            color: "#000",
                            // textDecoration: "underline",
                            // textDecorationStyle: "dotted",
                            textUnderlineOffset: 2,
                            paddingLeft: 4,
                          }}
                        >
                          {rule.title}
                        </Text>
                      </Flex>

                      <Flex align="center" gap={12}>
                        {rule.conditionType && (
                          <Text
                            style={{
                              fontSize: 12,
                              color: "#5E5E5E",
                              minWidth: 40,
                              textAlign: "right",
                            }}
                          >
                            {rule.conditionType}
                          </Text>
                        )}

                        <Flex
                          align="center"
                          justify="space-between"
                          style={{
                            background: "#F5F5F5",
                            borderRadius: "8px",
                            padding: "6px 12px",
                            width: 112,
                            height: 36,
                          }}
                        >
                          <Select
                            className="inputThreshold"
                            disabled={false}
                            value={thresholds[rule.id]?.toString()}
                            style={{
                              width: 50,
                              backgroundColor: "transparent",
                              border: "none",
                              textAlign: "left",
                            }}
                            options={getDropdownOptions(rule.unit).map(
                              (val) => ({
                                label: val,
                                value: val,
                              })
                            )}
                            onChange={(val) => handleChange(rule.id, val)}
                            suffixIcon={null}
                            dropdownStyle={{ minWidth: 80 }}
                          />
                          <Text
                            style={{
                              fontWeight: 600,
                              fontSize: 12,
                              color: "#000",
                              marginLeft: 4,
                            }}
                          >
                            {rule.unit}
                          </Text>
                        </Flex>

                        <div
                          style={{
                            width: 36,
                            height: 36,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            visibility: showResetIcon ? "visible" : "hidden",
                          }}
                        >
                          <Tooltip title="Reset to default">
                            <img
                              src={refreshIcon}
                              alt="reset"
                              width={36}
                              height={36}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                const fallbackValue = compareAgainst?.[rule.id];
                                if (fallbackValue !== undefined) {
                                  handleChange(rule.id, fallbackValue);
                                }
                              }}
                            />
                          </Tooltip>
                        </div>

                        <Tooltip title="Remove">
                          <DeleteFilled
                            style={{
                              fontSize: 16,
                              color: "#000",
                              cursor: "pointer",
                              marginRight: 10,
                            }}
                            onClick={() => handleDelete(rule.id)}
                          />
                        </Tooltip>
                      </Flex>
                    </Flex>

                    <Divider
                      style={{
                        borderColor: "#D9D9D9",
                        margin: "12px 0",
                      }}
                    />
                  </React.Fragment>
                );
              })
          )}
        </div>
      )}
      {step === 3 && (
        <div
          style={{
            overflowY: "auto",
            maxHeight: "500px",
            maxWidth: "100%",
            paddingRight: "8px",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <CustomTitle
              text="Add alert types"
              fontSize="20px"
              fontWeight="700"
              lineHeight="28px"
              color="black"
              marginBottom="10px"
            />
            <Flex vertical gap={8}>
              <CustomTitle
                text={title}
                fontSize={20}
                fontWeight="700"
                color="#000"
                marginBottom="0px"
              />
            </Flex>
          </div>
          {patchedConfig.map((group, index) => (
            <React.Fragment key={group.category}>
              {index !== 0 && (
                <Divider
                  style={{
                    borderColor: "#D9D9D9",
                    margin: "0px",
                  }}
                />
              )}

              <CustomTitle
                text={group.category}
                fontSize={14}
                fontWeight="600"
                color="#000"
                marginTop={15}
                marginBottom="0px"
              />

              <Flex align="flex-start">
                <Flex vertical style={{ flex: 1 }}>
                  {group.rules.map((rule) => {
                    const isSelected = selectedThresholds.includes(rule.id);
                    return (
                      <div
                        key={rule.id}
                        style={{
                          backgroundColor: isSelected
                            ? "#EFF4FE"
                            : "transparent",
                          borderRadius: "8px",
                          paddingLeft: "8px",
                          marginBottom: "2px",
                        }}
                      >
                        <ShipmentAlertThresholdInput
                        shipment={shipment}
                        group={group}
                          setupSensorRuleIds={setupSensorRuleIds}
                          teamsOptions={teamsOptions}
                          selectedTeam={selectedTeam}
                          allTeamThresholds={allTeamThresholds}
                          thresholds={thresholds}
                          defaultThresholds={defaultThresholds}
                          disabled={buttonsDisabled}
                          setupSensor={setupSensor}
                          navigate={navigate}
                          rule={rule}
                          value={thresholds[rule.id]}
                          onChange={handleChange}
                          isChecked={isSelected}
                          onCheckboxChange={(checked) => {
                            setSelectedThresholds((prev) =>
                              checked
                                ? [...prev, rule.id]
                                : prev.filter((id) => id !== rule.id)
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                </Flex>
              </Flex>
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
};

export default ShipmentAlertThresholds;
